import React from 'react';
import debounce from 'lodash/debounce';
import { useNavigate } from 'react-router';
import { useExperimentsStore } from 'apps/experiments/src/store';
import { Experiment } from 'apps/experiments/src/types';
import { useTranslation } from 'common/i18n/hooks';
import { TableGroup, useColumnSelectionStorage } from 'common/components/table-react';
import { createTableHelper } from 'common/components/table-react/helpers';
import { Row } from 'common/components/table-react/types';
import { getReportUrl } from 'common/report/util';
import { useExperimentPageContext } from 'apps/experiments/src/components/context';
import { ReportBannersReact } from 'common/widgets/report-banners';
import { isTestEnv } from 'common/report/util/env';
import styles from './index.module.styl';
import { customCellTypesCallback } from './custom-cell-types';
import { ExperimentsLimitBanner } from './limit-banner';
import { useExperimentColumns } from './hooks/useExperimentColumns';
import { useExperimentFilters } from './hooks/useExperimentFilters';
const tableHelper = createTableHelper<Experiment>();
export function ExperimentListPageMain() {
  const i18n = useTranslation();
  const navigate = useNavigate();
  const {
    projectId,
    workspaceId,
    userId
  } = useExperimentPageContext();
  const experiments = useExperimentsStore(state => state.experiments);
  const columns = useExperimentColumns();
  const {
    modifiedTableColumns,
    saveColumnSelections,
    saveColumnSize
  } = useColumnSelectionStorage("experiments-list", columns, true);
  const customCellTypes = customCellTypesCallback(tableHelper, i18n);
  const handleRowClick = (row: Row<Experiment>) => {
    navigate(getReportUrl("experiments/".concat(row.original.id), {
      projectId,
      workspaceId
    }));
  };
  const {
    filtersState,
    getCustomColumnFilters,
    handleFilterReset
  } = useExperimentFilters({
    experiments,
    userId
  });
  return <main className={styles.main} data-sentry-component="ExperimentListPageMain" data-sentry-source-file="index.tsx">
      {!isTestEnv() && <ReportBannersReact />}
      <ExperimentsLimitBanner data-sentry-element="ExperimentsLimitBanner" data-sentry-source-file="index.tsx" />
      <div className={styles.tableWrapper}>
        <TableGroup columns={modifiedTableColumns} data={experiments !== null && experiments !== void 0 ? experiments : []} customCellTypes={customCellTypes} initializedColumnFilterState={filtersState} defaultColumnFilterState={[]} defaultSorting={[{
        id: "status",
        desc: false
      }]} data-sentry-element="TableGroup" data-sentry-source-file="index.tsx">
          <TableGroup.FilterSelectionBar overrideColumnFilterControl={getCustomColumnFilters} filterSearchPlaceholder={i18n.t("experiments.list.search-placeholder")} enableColumnSelection onColumnSelectionChange={saveColumnSelections} onFilterReset={handleFilterReset} data-sentry-element="unknown" data-sentry-source-file="index.tsx" />
          <TableGroup.Table onRowClick={handleRowClick} enableColumnReordering enableColumnResizing minTableWidth='100%' fillHeight onColumnReorder={saveColumnSelections} onColumnResize={debounce(saveColumnSize, 500)} data-sentry-element="unknown" data-sentry-source-file="index.tsx" />
        </TableGroup>
      </div>
    </main>;
}